const steps = [
  {
    icon: "ri-inbox-archive-line",
    title: "采集线索",
    desc: "收集公开材料、当事人陈述与网友整理内容，先做一轮基本要素筛查：有没有时间、地点、可核对的载体。",
  },
  {
    icon: "ri-stack-line",
    title: "来源分级",
    desc: "把每条线索标注为公开记录、官方物料、当事人陈述或匿名转述，等级不同，在评分中的权重也不同。",
  },
  {
    icon: "ri-node-tree",
    title: "交叉印证",
    desc: "寻找彼此独立的来源是否能指向同一结论，同时排查同源转发，避免把一个声音误当成多方印证。",
  },
  {
    icon: "ri-file-chart-line",
    title: "公开结论",
    desc: "给出可信度分数与结论标签，列出证据链与待确认环节；出现新材料时公开更新并保留修改记录。",
  },
];

export default function MethodSteps() {
  return (
    <section id="method-preview" className="border-b border-background-200 bg-background-100">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
            鉴定方法
          </p>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
            一条瓜进入瓜田，会经过这四步
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            流程固定、标准公开，任何人都可以照着同样的路径复核我们的结论。
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {steps.map((step, index) => (
            <li
              key={step.title}
              className="relative border border-background-200 rounded-card bg-background-50 p-5 md:p-6"
            >
              <span className="font-mono-num text-xs text-foreground-300">
                STEP {String(index + 1).padStart(2, "0")}
              </span>
              <span className="mt-4 w-11 h-11 flex items-center justify-center rounded-control bg-secondary-100 text-secondary-700">
                <i className={`${step.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}